import { useContext, useMemo } from 'react'

import { OptimizelyContext } from '@optimizely/react-sdk'
import { useSelector } from 'react-redux'

import { useDeliveryDateDiscount } from 'hooks/promotions/useDeliveryDateDiscount'
import { isBasketTransactionalOrder } from 'selectors/basket'

import type { DiscountBadgeCopy } from './formatDiscountBadge'
import { formatDiscountBadge } from './formatDiscountBadge'

const DISCOUNT_BADGE_FLAG = 'tomatoes_ofx_webclient_discount_visibility_menu'

export const useDiscountBadge = ({ enabled }: { enabled: boolean }): DiscountBadgeCopy | null => {
  const { optimizely } = useContext(OptimizelyContext)
  const isTransactional = useSelector(isBasketTransactionalOrder)

  // Gate the fetch on the flag so the endpoint isn't hit when off.
  const flagEnabled = useMemo(
    () => (optimizely && enabled ? optimizely.decide(DISCOUNT_BADGE_FLAG).enabled : false),
    [optimizely, enabled],
  )

  const discount = useDeliveryDateDiscount({
    enabled: enabled && flagEnabled,
    boxType: isTransactional ? 'transactional' : 'subscription',
  })

  return discount ? formatDiscountBadge(discount) : null
}
